// extracted by mini-css-extract-plugin
module.exports = {"column":"FooterColumnSkeleton_column__vpUkC"};